/* global ReactOnRails:false */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import internationalize from '../../lib/internationalize';
/*
 * This component shared some code with the run_player, since it emulates the behaviour of the
 * run player for bulk anserwing focus tests.
 */

import { numberOfGlyphsPerLine } from '../run_player/components/screens/focus_test';
import { generate } from '../run_player/components/screens/focus_test/utils';
import Description from '../run_player/components/screens/focus_test/description';
import OfflineIntro from '../run_player/components/screens/focus_test/board/offline_intro';
import SyncClient from '../run_player/sync';
import * as alphabets from '../run_player/data/alphabets';

function BulkFocusTest({
  alphabet: alphabetId,
  runtime,
  runId,
  exerciseId,
  numberOfLines
}) {
  const alphabet = alphabets[alphabetId];
  useEffect(() => {
    const sequence = generate(alphabet, numberOfGlyphsPerLine, numberOfLines);

    const run = { id: runId };

    const client = new SyncClient({
      headers: ReactOnRails.authenticityHeaders
    });
    client.push(run, {
      data: {
        type: 'events',
        attributes: {
          event_type: 'answered',
          exercise_id: exerciseId,
          answer: {
            focusTestMode: 'focus_test_mode:offline',
            sequence
          }
        }
      }
    });
  });

  return (
    <>
      <div className="l-grid">
        <div className="l-grid__item l-width--8-of-12@medium">
          <Description alphabet={alphabet} alphabetId={alphabetId} />
        </div>
      </div>
      <OfflineIntro runtime={runtime} runId={runId} exerciseId={exerciseId} />
    </>
  );
}

BulkFocusTest.propTypes = {
  alphabet: PropTypes.string.isRequired,
  numberOfLines: PropTypes.number.isRequired,
  runtime: PropTypes.number.isRequired,
  runId: PropTypes.string.isRequired,
  exerciseId: PropTypes.string.isRequired
};

export default internationalize(BulkFocusTest);
